import ReportingPeriod, {
  IReportingPeriod
} from "../../../model/reporting/ReportingPeriod";
import { formatBooleanValue } from "../../..";

async function ReportingPeriodListMapper(
  data: any
): Promise<IReportingPeriod[]> {
  return Promise.all(
    data.map((item: any) => {
      let reportingPeriod = ReportingPeriod(item);
      reportingPeriod.valid = formatBooleanValue(item.valid);
      return reportingPeriod;
    })
  );
}

export default ReportingPeriodListMapper;
